module.exports = __webpack_public_path__ + "media/placeholder.b7984886.png";